<template>
  <div class="profile-form-card">
    <el-form ref="form" class="profile-form" :model="formData" size="small" :rules="rules" label-position="top">
      <el-row :gutter="22">
        <el-col :xs="24" :sm="12">
          <el-form-item label="真实姓名" prop="name">
            <el-input v-model="formData.name" placeholder="真实姓名" prefix-icon="el-icon-user"/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="用户昵称" prop="nickname">
            <el-input v-model="formData.nickname" placeholder="用户昵称" prefix-icon="el-icon-user-solid"/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="formData.mobile" maxlength="11" placeholder="手机号码" prefix-icon="el-icon-mobile-phone"/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="formData.email" maxlength="50" placeholder="邮箱" prefix-icon="el-icon-message"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="form-actions">
            <el-button type="primary" @click="submit">保存</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'userInfo',
  props: {
    user: {
      type: Object
    }
  },
  computed: {
    formData: {
      get() {
        return this.user
      },
      set(val) {
        this.$emit('update:user', val)
      }
    }
  },
  data() {
    return {
      // 表单校验
      rules: {
        nickname: [
          { required: true, message: '用户昵称不能为空', trigger: 'blur' }
        ],
        email: [
          { required: false, message: '邮箱地址不能为空', trigger: 'blur' },
          {
            type: 'email',
            message: '\'请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ],
        mobile: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    async submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          //修改个人信息，不需要用户ID
          const postData = {
            // id: this.formData.id,
            nickname: this.formData.nickname,
            name: this.formData.name,
            mobile: this.formData.mobile,
            email: this.formData.email,
          }
          const info = this.$api.updateUserProfile(postData)
          if (info) {
            this.$notify.success(`修改成功`)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.profile-form-card {
  max-width: 760px;
}

.profile-form ::v-deep .el-form-item {
  margin-bottom: 18px;
}

.profile-form ::v-deep .el-form-item__label {
  padding-bottom: 7px;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.profile-form ::v-deep .el-input__inner {
  height: 36px;
  border-color: #d8dee9;
  border-radius: 6px;
  color: #1f2937;
}

.profile-form ::v-deep .el-input__inner:focus {
  border-color: #ff3176;
}

.profile-form ::v-deep .el-input__prefix {
  color: #98a2b3;
}

.form-actions {
  margin-top: 6px;
  padding-top: 18px;
  border-top: 1px solid #edf1f6;
  text-align: right;
}

.form-actions ::v-deep .el-button {
  min-width: 96px;
  height: 36px;
  border-radius: 6px;
  font-weight: 600;
}
</style>
